<app-loader *ngIf="isDisabled"></app-loader>
<div class="modal-header">
    <h6 class="modal-title"><i class="bi bi-shield-check"></i> Manual BGV</h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<div class="card">
    <form class="g-3" name="BGVMenualForm" (ngSubmit)="Validate(BGVMenualForm)" #BGVMenualForm="ngForm" novalidate>
        <div class="card-body p-0">
            <div class="card mb-1">
                <div class="card-body">
                    <div class="row mb-2">
                        <div class="col-md-4">
                            <label for="ESS_BGVAPIMasterID" class="text-label-dark">Vendor<span
                                    class="mandatory-field">*</span></label>
                            <ng-select name="ESS_BGVAPIMasterID" placeholder="Select Vendor"
                                [(ngModel)]="this.Details.ESS_BGVAPIMasterID" [selectOnTab]="true"
                                (change)="this.ESS_BGVFillCombo('BS');this.ESS_BGVFillCombo('VT');" 
                                [disabled]="this.ESS_BGVAPIMasterID > 0" required>
                                <ng-option *ngFor="let Vendor of Vendors"
                                    [value]="Vendor.ESS_BGVApiMasterID">{{Vendor.APIName}}</ng-option>
                            </ng-select>
                        </div>
                        <div class="col-md-4">
                            <label for="VerificationType" class="text-label-dark">Vendor Overall status<span
                                    class="mandatory-field">*</span></label>
                            <ng-select name="VerificationType" placeholder="Select status"
                                [(ngModel)]="this.Details.VerificationType" [selectOnTab]="true" 
                                (change)="changeFinalstausConfirmation()" 
                                [disabled]="this.ESS_BGVAPIMasterID > 0" required>
                                <ng-option *ngFor="let BgvStatu of BgvStatus" [value]="BgvStatu.Status"><span
                                        style="width: 15px;height: 15px; display: inline-flex;"
                                        [ngStyle]="{ 'background':BgvStatu.ColourCode}"></span>
                                    {{BgvStatu.Status}}</ng-option>
                            </ng-select>
                        </div>
                        <div class="col-md-12">
                            <label for="VerificationTypeFinal" class="text-label-dark">Verification Type<span
                                    class="mandatory-field">*</span></label>
                            <ng-select name="VerificationTypeFinal" placeholder="Select Type"
                                [(ngModel)]="this.Details.VerificationTypeFinal" [selectOnTab]="true" 
                                [disabled]="this.ESS_BGVAPIMasterID > 0" required>
                                <ng-option *ngFor="let VerificationType of VerificationTypes"
                                    [value]="VerificationType.CheckListCode">({{VerificationType.CheckListCode}})
                                    {{VerificationType.CheckListName}}</ng-option>
                            </ng-select>
                        </div>
                    </div>
                    <div class="row mb-2"
                        *ngIf="this.Details.ESS_BGVAPIMasterID != null && this.Details.VerificationType != null">
                        <div class="col-md-4">
                            <label for="InitiatedOn" class="text-label-dark">Initiated Date <span
                                    class="mandatory-field">*</span></label>
                            <div class="input-group">
                                <input class="form-control" placeholder="DD MMM YYYY" name="InitiatedOn"
                                    [(ngModel)]="this.Details.ESS_EmpBGVVerificationDetails_Manual[0].InitiatedOn"
                                    ngbDatepicker #InitiatedOn="ngbDatepicker"
                                    [minDate]="getLowestDateVariable()" [maxDate]="Today" required readonly
                                    [disabled]="this.ESS_BGVAPIMasterID > 0"  />
                                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="InitiatedOn.toggle()"
                                    type="button"></button>
                            </div>
                            <div class="invalid-feedback">
                                Please enter initiated date.
                            </div>
                        </div>
                        <div class="col-md-8">
                            <label for="MenualBGVAttachment" class="text-label-dark">Report</label>
                            <br />
                            <Input id="contained-button-file"
                                *ngIf="this.Details.ESS_EmpBGVVerificationDetails_Manual[0].FileName == null && this.FileNameURL == null"
                                (change)="upload($event,common.CompanyParameterValue.MenualBGVAttachment)"
                                name="MenualBGVAttachment" accept=".jpeg,.jpg,.png,.pdf" type="file"
                                #MenualBGVAttachment required ngbTooltip="Choose File"
                                [disabled]="this.ESS_BGVAPIMasterID > 0"  />

                            <a role="button" target="blank" [href]="this.FileNameURL" class="btn btn-primary me-2"
                                *ngIf="this.Details.ESS_EmpBGVVerificationDetails_Manual[0].FileName != null && this.FileNameURL != null"><i
                                    class="bi bi-file-earmark"></i></a>
                            <button type="button" (click)="RemoveAttachment()" class="btn btn-danger"
                                *ngIf="this.Details.ESS_EmpBGVVerificationDetails_Manual[0].FileName != null && this.FileNameURL != null"
                                [disabled]="this.ESS_BGVAPIMasterID > 0"><i
                                    class="bi bi-trash"></i></button>
                        </div>
                    </div>
                    <div class="row mb-2" *ngIf="this.common.ToLowerCase(this.Details.VerificationTypeFinal) == 'crc'">
                        <div class="col-md-6">
                            <label for="LocalAddress1" class="text-label-dark">Address 1 <span
                                    class="mandatory-field">*</span></label>
                            <textarea type="text" class="form-control address" placeholder="Ex. 100 Main ST"
                                id="LocalAddress1" name="LocalAddress1"
                                [(ngModel)]="this.Details.ESS_EmpBGVVerificationDetails_Manual[0].LocalAddress1"
                                #LocalAddress1="ngModel" required maxlength="200" 
                                [disabled]="this.ESS_BGVAPIMasterID > 0"></textarea>
                            <div class="invalid-feedback">
                                Please enter address 1 with maximum limit 200!
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label for="LocalAddress2" class="text-label-dark">Address 2</label>
                            <textarea type="text" class="form-control address" placeholder="Ex. 100 Main ST"
                                id="LocalAddress2" name="LocalAddress2"
                                [(ngModel)]="this.Details.ESS_EmpBGVVerificationDetails_Manual[0].LocalAddress2"
                                #LocalAddress2="ngModel" maxlength="200"
                                [disabled]="this.ESS_BGVAPIMasterID > 0" ></textarea>
                        </div>
                    </div>
                    <div class="row mb-2" *ngIf="this.common.ToLowerCase(this.Details.VerificationTypeFinal) == 'eav'">
                        <div class="col-md-6">
                            <label for="Address1" class="text-label-dark">Address 1 <span
                                    class="mandatory-field">*</span></label>
                            <textarea type="text" class="form-control address" placeholder="Ex. 100 Main ST"
                                id="Address1" name="Address1"
                                [(ngModel)]="this.Details.ESS_EmpBGVVerificationDetails_Manual[0].Address1"
                                #Address1="ngModel" required maxlength="200"
                                [disabled]="this.ESS_BGVAPIMasterID > 0" ></textarea>
                            <div class="invalid-feedback">
                                Please enter address 1 with maximum limit 200!
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label for="Address2" class="text-label-dark">Address 2</label>
                            <textarea type="text" class="form-control address" placeholder="Ex. 100 Main ST"
                                id="Address2" name="Address2"
                                [(ngModel)]="this.Details.ESS_EmpBGVVerificationDetails_Manual[0].Address2"
                                #Address2="ngModel" maxlength="200"
                                [disabled]="this.ESS_BGVAPIMasterID > 0" ></textarea>
                        </div>
                    </div>
                    <div class="row mb-2" *ngIf="this.common.ToLowerCase(this.Details.VerificationTypeFinal) == 'ev'">
                        <div class="col-md-6">
                            <label for="PrevCompanyName" class="text-label-dark">Employment Name <span
                                    class="mandatory-field">*</span></label>
                            <input type="text" class="form-control" placeholder="Ex. XYZ Company" name="PrevCompanyName"
                                [(ngModel)]="this.Details.ESS_EmpBGVVerificationDetails_Manual[0].PrevCompanyName"
                                #PrevCompanyName="ngModel" maxlength="100" required
                                [disabled]="this.ESS_BGVAPIMasterID > 0" >
                            <div class="invalid-feedback">
                                Please enter employment name.
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label for="PrevCompanyPosition" class="text-label-dark">Position <span
                                    class="mandatory-field">*</span></label>
                            <input type="text" class="form-control" placeholder="Ex. Manager" name="PrevCompanyPosition"
                                [(ngModel)]="this.Details.ESS_EmpBGVVerificationDetails_Manual[0].PrevCompanyPosition"
                                #PrevCompanyPosition="ngModel" maxlength="100" required
                                [disabled]="this.ESS_BGVAPIMasterID > 0" >
                            <div class="invalid-feedback">
                                Please enter position.
                            </div>
                        </div>
                    </div>
                    <div class="row mb-2" *ngIf="this.common.ToLowerCase(this.Details.VerificationTypeFinal) == 'ev'">
                        <div class="col-md-4">
                            <label for="PrevCompanyJoiningDate" class="text-label-dark">Joining Date <span class="mandatory-field">*</span></label>
                            <div class="input-group">
                                <input class="form-control" placeholder="DD MMM YYYY" name="PrevCompanyJoiningDate"
                                    [(ngModel)]="this.Details.ESS_EmpBGVVerificationDetails_Manual[0].PrevCompanyJoiningDate"
                                    ngbDatepicker #PrevCompanyJoiningDate="ngbDatepicker" required [minDate]="BirthDate"
                                    [maxDate]="JoiningDate" readonly 
                                    [disabled]="this.ESS_BGVAPIMasterID > 0" />
                                <button class="btn btn-outline-secondary bi bi-calendar3"
                                    (click)="PrevCompanyJoiningDate.toggle()" type="button"></button>
                            </div>
                            <div class="invalid-feedback">
                                Please enter from date.
                            </div>
                        </div>
                        <div class="col-md-4">
                            <label for="PrevCompanyRelievingDate" class="text-label-dark">Relieving Date <span class="mandatory-field">*</span></label>
                            <div class="input-group">
                                <input class="form-control" placeholder="DD MMM YYYY" name="PrevCompanyRelievingDate"
                                    [(ngModel)]="this.Details.ESS_EmpBGVVerificationDetails_Manual[0].PrevCompanyRelievingDate"
                                    ngbDatepicker #PrevCompanyRelievingDate="ngbDatepicker"
                                    [minDate]="this.Details.ESS_EmpBGVVerificationDetails_Manual[0].PrevCompanyJoiningDate"
                                    [maxDate]="JoiningDate" required readonly 
                                    [disabled]="this.ESS_BGVAPIMasterID > 0" />
                                <button class="btn btn-outline-secondary bi bi-calendar3"
                                    (click)="PrevCompanyRelievingDate.toggle()" type="button" [disabled]="this.ESS_BGVAPIMasterID > 0" ></button>
                            </div>
                            <div class="invalid-feedback">
                                Please enter to date.
                            </div>
                        </div>
                    </div>
                    <div class="row mb-2" *ngIf="this.common.ToLowerCase(this.Details.VerificationTypeFinal) == 'eqv'">
                        <div class="col">
                            <div class="row">
                                <div class="col-md mx-1 p-0">
                                    <label for="QualificationName" class="text-label-dark">Qualification<span
                                            class="mandatory-field">*</span></label>
                                    <input type="text" class="form-control" placeholder="Ex. MCA" id="QualificationName"
                                        name="QualificationName"
                                        [(ngModel)]="this.Details.ESS_EmpBGVVerificationDetails_Manual[0].QualificationName"
                                        #QualificationName="ngModel" maxlength="300" required
                                        [disabled]="this.ESS_BGVAPIMasterID > 0" >
                                    <div class="invalid-feedback">
                                        Please enter qualification!
                                    </div>
                                </div>
                                <div class="col-md mx-1 p-0">
                                    <label for="UniversityBoard" class="text-label-dark">University/Board
                                        <span class="mandatory-field">*</span></label>
                                    <input type="text" class="form-control" placeholder="Ex. Mumbai University"
                                        id="UniversityBoard" name="UniversityBoard"
                                        [(ngModel)]="this.Details.ESS_EmpBGVVerificationDetails_Manual[0].UniversityBoard"
                                        #UniversityBoard="ngModel" maxlength="300" required
                                        [disabled]="this.ESS_BGVAPIMasterID > 0" >
                                    <div class="invalid-feedback">
                                        Please enter university/board.
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md mx-1 p-0">
                                    <label for="EnrollmentNumber" class="text-label-dark">Enrollment No
                                        <span class="mandatory-field">*</span></label>
                                    <input class="form-control" placeholder="Ex. 00128" id="EnrollmentNumber"
                                        name="EnrollmentNumber"
                                        [(ngModel)]="this.Details.ESS_EmpBGVVerificationDetails_Manual[0].EnrollmentNumber"
                                        #EnrollmentNumber="ngModel" maxlength="25" required
                                        [disabled]="this.ESS_BGVAPIMasterID > 0" >
                                    <div class="invalid-feedback">
                                        Please enter enrollment number
                                    </div>
                                </div>
                                <div class="col-md mx-1 p-0">
                                    <label for="College" class="text-label-dark">College <span
                                            class="mandatory-field">*</span></label>
                                    <input class="form-control" placeholder="Ex. College" id="College" name="College"
                                        [(ngModel)]="this.Details.ESS_EmpBGVVerificationDetails_Manual[0].College"
                                        #College="ngModel" maxlength="100" required
                                        [disabled]="this.ESS_BGVAPIMasterID > 0" >
                                    <div class="invalid-feedback">
                                        Please enter college
                                    </div>
                                </div>
                                <div class="col-md mx-1 p-0">
                                    <label for="CGPA" class="text-label-dark">CGPA <span
                                            class="mandatory-field">*</span></label>
                                    <input class="form-control" placeholder="Ex. CGPA" id="CGPA" name="CGPA"
                                        [(ngModel)]="this.Details.ESS_EmpBGVVerificationDetails_Manual[0].CGPA"
                                        #CGPA="ngModel" minlength="1" maxlength="2"
                                        (keypress)="common.NumberOnly($event,true)"
                                        (keyup)="common.NumberOnly($event,true)" pattern="^[0-9.]*$" required
                                        [disabled]="this.ESS_BGVAPIMasterID > 0" >
                                    <div class="invalid-feedback">
                                        Please enter cgpa
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-2"
                        *ngIf="this.Details.ESS_BGVAPIMasterID != null && this.Details.VerificationTypeFinal != null">
                        <div class="col-md-3">
                            <label for="Verification_Status" class="text-label-dark">Verification Status <span
                                    class="mandatory-field">*</span></label>
                            <ng-select name="Verification_Status" placeholder="Verification Status"
                                [(ngModel)]="this.Details.ESS_EmpBGVVerificationDetails_Manual[0].Verification_Status"
                                [selectOnTab]="true" required>
                                <ng-option *ngFor="let BgvStatu of BgvStatus" [value]="BgvStatu.Status"><span
                                        style="width: 15px;height: 15px; display: inline-flex;"
                                        [ngStyle]="{ 'background':BgvStatu.ColourCode}"></span>
                                    {{BgvStatu.Status}}</ng-option>
                            </ng-select>
                            <div class="invalid-feedback">
                                Please select verification status
                            </div>

                            <br />

                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" name="IsVerified" id="IsVerified"
                                    [(ngModel)]="this.Details.ESS_EmpBGVVerificationDetails_Manual[0].IsVerified"
                                    [disabled]="this.ESS_BGVAPIMasterID > 0" >
                                <label class="text-label-dark" for="IsVerified">
                                    Is Verified
                                </label>
                            </div>
                        </div>
                        <div class="col-md">
                            <label for="Status_Description" class="text-label-dark">Status Description <span
                                    class="mandatory-field">*</span></label>
                            <textarea type="text" class="form-control address" id="Status_Description"
                                name="Status_Description"
                                [(ngModel)]="this.Details.ESS_EmpBGVVerificationDetails_Manual[0].Status_Description"
                                #Status_Description="ngModel" required maxlength="200"></textarea>
                            <div class="invalid-feedback">
                                Please enter status description with maximum limit 200!
                            </div>
                        </div>
                        <div class="col-md">
                            <label for="Remarks" class="text-label-dark">Remarks <span
                                    class="mandatory-field">*</span></label>
                            <textarea type="text" class="form-control address" id="Remarks" name="Remarks"
                                [(ngModel)]="this.Details.ESS_EmpBGVVerificationDetails_Manual[0].Remarks"
                                #Remarks="ngModel" required maxlength="200"></textarea>
                            <div class="invalid-feedback">
                                Please enter remarks with maximum limit 200!
                            </div>
                        </div>
                    </div>
                    <div class="row"
                        *ngIf="this.Details.ESS_BGVAPIMasterID != null && this.Details.VerificationTypeFinal != null">
                        <div class="col"></div>
                        <div class="col-auto">
                            <button class="btn btn-primary btn-sm" [disabled]="isDisabled"><i class="bi bi-download"
                                    *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Save':'Loading...'}}</button>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                        (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Cancel':'Loading...'}}</button>
                </div>
            </div>
        </div>
    </form>
</div>